module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Optimism Made Simple: Proof That Positive Thinking Works!")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By Hilary Walker")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "a3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/005#a11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/006#a15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: The Shuttle That Shouldn’t Have")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/007#a16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The Greedy Farmer")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/008#a18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Another Farm Tries It On")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/009#a20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Beating Bell’s Palsy")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/010#a22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Unexpected Benefits of Prayer")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-052cac22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0